/**
 * GalleryMasonry
 * CSS columns masonry grid with hover zoom + lightbox trigger.
 *
 * Props:
 *   images        — array of { id, src, title }
 *   onImageClick  — called with image index when clicked
 */
const GalleryMasonry = ({ images = [], onImageClick }) => (
    <div className="columns-2 sm:columns-3 md:columns-4 lg:columns-5 gap-3 space-y-3">
        {images.map((img, idx) => (
            <div
                key={img.id}
                className="break-inside-avoid group relative overflow-hidden rounded-lg cursor-pointer"
                onClick={() => onImageClick(idx)}
            >
                <img
                    src={img.src}
                    alt={img.title || `Gallery ${idx + 1}`}
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-primary-950/0 group-hover:bg-primary-950/40 transition-all duration-300 flex items-center justify-center">
                    <svg
                        className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                </div>
            </div>
        ))}
    </div>
);

export default GalleryMasonry;
